import { createContext, useContext, useEffect } from "react";

/** NexTerminal is dark-only (brand mandate). This provider keeps a stable
 *  API for any consumer but always forces the dark theme onto the DOM. */
const ThemeContext = createContext({
    theme: "dark",
    setTheme: () => {},
    toggleTheme: () => {},
});

export function ThemeProvider({ children }) {
    useEffect(() => {
        if (typeof document === "undefined") return;
        document.documentElement.setAttribute("data-theme", "dark");
        document.documentElement.classList.add("dark");
        document.documentElement.style.colorScheme = "dark";
        try {
            window.localStorage.setItem("cm.theme", "dark");
        } catch (_) {
            /* ignore */
        }
    }, []);

    return (
        <ThemeContext.Provider value={{ theme: "dark", setTheme: () => {}, toggleTheme: () => {} }}>
            {children}
        </ThemeContext.Provider>
    );
}

export function useTheme() {
    return useContext(ThemeContext);
}
